<ul class="share-links__list">
    <li class="share-links__item share-links__item--type--like"><a href="">Like</a></li>
    <li class="share-links__item share-links__item--type--tweet"><a href="">Tweet</a></li>
    <li class="share-links__item share-links__item--type--pin"><a href="">Pin It</a></li>
    <li class="share-links__item share-links__item--type--counter"><a href="">4K</a></li>
</ul>
